import { createSelector } from "reselect";
import { selectFromAddress } from "storage/inbounds/create/store/selector/selectFromAddress";

export const selectHasFromAddress = createSelector(
  selectFromAddress,
  (fromAddress) => fromAddress?.country.trim().length > 0
);
